import { render, staticRenderFns } from "./DataConfig.vue?vue&type=template&id=8dbb2b24&scoped=true"
import script from "./DataConfig.vue?vue&type=script&lang=js"
export * from "./DataConfig.vue?vue&type=script&lang=js"
import style0 from "./DataConfig.vue?vue&type=style&index=0&id=8dbb2b24&prod&scoped=true&lang=css"
import style1 from "./DataConfig.vue?vue&type=style&index=1&id=8dbb2b24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbb2b24",
  null
  
)

export default component.exports